import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, label: String, resourceName: String, redirect: String }

  show(event) {
    event.preventDefault()
    this._renderModal()
  }

  _renderModal() {
    document.getElementById("admin-confirm-modal")?.remove()

    const modal = document.createElement("div")
    modal.id = "admin-confirm-modal"
    modal.className = "fixed inset-0 z-50 flex items-center justify-center"
    modal.innerHTML = `
      <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" id="admin-confirm-backdrop"></div>
      <div class="relative bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 p-6">
        <div class="flex items-start gap-4 mb-4">
          <div class="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
            <svg class="w-5 h-5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <div>
            <h3 class="text-base font-semibold text-gray-900">Delete ${this.resourceNameValue}?</h3>
            <p class="text-sm text-gray-500 mt-0.5">${this.labelValue}</p>
          </div>
        </div>
        <p class="text-sm text-gray-600 mb-6">
          This action <strong class="text-gray-800">cannot be undone</strong>.
          This will permanently delete this record and all associated data.
        </p>
        <div class="flex gap-3 justify-end">
          <button type="button" id="admin-confirm-cancel"
                  class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
            Cancel
          </button>
          <button type="button" id="admin-confirm-delete"
                  class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors cursor-pointer">
            Delete ${this.resourceNameValue}
          </button>
        </div>
      </div>
    `

    document.body.appendChild(modal)

    this._keydownHandler = (e) => { if (e.key === "Escape") this._dismiss() }
    document.addEventListener("keydown", this._keydownHandler)

    modal.querySelector("#admin-confirm-backdrop").addEventListener("click", () => this._dismiss())
    modal.querySelector("#admin-confirm-cancel").addEventListener("click", () => this._dismiss())
    modal.querySelector("#admin-confirm-delete").addEventListener("click", () => this._execute())

    modal.querySelector("#admin-confirm-cancel").focus()
  }

  _dismiss() {
    document.getElementById("admin-confirm-modal")?.remove()
    document.removeEventListener("keydown", this._keydownHandler)
  }

  _execute() {
    this._dismiss()
    if (this.redirectValue) {
      fetch(this.urlValue, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "text/html"
        }
      }).then(() => Turbo.visit(this.redirectValue))
    } else {
      fetch(this.urlValue, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "text/vnd.turbo-stream.html"
        }
      }).then(r => r.text()).then(html => Turbo.renderStreamMessage(html))
    }
  }
}
